import { __assign, __rest } from "tslib";
import React from 'react';
import styles from './styles.css.js';
function StaticNotifications(_a) {
    var children = _a.children, labels = _a.labels;
    return (React.createElement("div", { className: styles.notifications, role: "region", "aria-label": labels === null || labels === void 0 ? void 0 : labels.notifications }, children));
}
function StickyNotifications(props) {
    return (React.createElement("div", { style: { top: props.topOffset }, className: styles['notifications-sticky'] },
        React.createElement(StaticNotifications, __assign({}, props))));
}
export function Notifications(_a) {
    var sticky = _a.sticky, rest = __rest(_a, ["sticky"]);
    return sticky ? React.createElement(StickyNotifications, __assign({}, rest)) : React.createElement(StaticNotifications, __assign({}, rest));
}
